/* Pizeta Cart — Codice Fiscale
   - calcolo automatico dai dati anagrafici: comuni italiani e stati esteri (codice Z)
   - autocomplete "Comune o stato di nascita" su dati serviti dal tema
     (assets/pz-cf-luoghi.json, generato da scripts/build-cf-luoghi.mjs; cache sessionStorage pz_luoghi_v2)
   - controllo del CF scritto a mano: formato e carattere di controllo, confronto con il CF calcolato
     al netto dell'omocodia; se non corrisponde ai dati il checkout si ferma (validateCF in
     sections/pizeta-cart.liquid) e si propone "Ricalcola dai dati". Bloccante anche la differenza
     (MC 26/10: un CF che differisce in anno o giorno non è una correzione dell'Agenzia delle Entrate)
   - attributi carrello aggiuntivi "CF calcolato" e "Controllo CF" (hidden input nel form)
   Le funzioni pure sono esportate per i test: node scripts/test-cf.mjs */
(function (root) {
  'use strict';

  var CACHE_KEY = 'pz_luoghi_v2';
  var luoghi = null;   // [{nome, en, cod, sigla, estero, keys[]}]
  var byName = {};     // chiave normalizzata (nome IT, nome EN, alias) -> record
  var loading = false;
  var waiting = [];

  /* Stati del controllo salvati nell'attributo "Controllo CF" (in italiano: li legge MC nell'ordine) */
  var ST_OK = 'ok';
  var ST_EDIT_OK = 'modificato a mano, corrisponde';
  var ST_EDIT_DIFF = 'modificato a mano, non corrisponde';
  var ST_EDIT_INVALID = 'modificato a mano, non valido';
  var ST_UNVERIFIABLE = 'inserito a mano, non verificabile';
  var CALC_NONE = 'non calcolabile';

  var TEXTS = {
    it: {
      empty: 'Nessun comune o stato trovato: controlla la scrittura. Se il luogo non c\'è, scrivilo per esteso e inserisci il codice fiscale a mano.',
      estero: 'Stato estero',
      groups: { stati: 'Stati esteri', word: 'Altri comuni' },
      invalidFormat: 'Il codice fiscale deve avere 16 caratteri, lettere e numeri (es. RSSMRA85M01H501Z).',
      invalidCin: 'Il codice fiscale contiene un errore: il carattere di controllo finale non corrisponde. Verifica di averlo copiato bene.',
      mismatch: 'Il codice fiscale non corrisponde ai dati inseriti ({parts}). Correggi i dati o il codice, oppure usa «Ricalcola dai dati».',
      unverifiable: 'Codice inserito a mano: non possiamo verificarlo perché il luogo di nascita non è in elenco.',
      omocodia: 'Codice fiscale con omocodia (lettere al posto delle cifre): corrisponde ai dati inseriti.',
      parts: { cognome: 'cognome', nome: 'nome', data: 'data di nascita o sesso', luogo: 'luogo di nascita' }
    },
    en: {
      empty: 'No municipality or country found: check the spelling. If your place of birth is not listed, type it in full and enter your tax code by hand.',
      estero: 'Country',
      groups: { stati: 'Countries', word: 'Other municipalities' },
      invalidFormat: 'The tax code must have 16 characters, letters and digits (e.g. RSSMRA85M01H501Z).',
      invalidCin: 'The tax code contains an error: the final check character does not match. Please verify you copied it correctly.',
      mismatch: 'The tax code does not match the details entered ({parts}). Correct the details or the code, or use “Recalculate from details”.',
      unverifiable: 'Code entered by hand: we cannot verify it because the place of birth is not in the list.',
      omocodia: 'Tax code with omocodia (letters replacing digits): it matches the details entered.',
      parts: { cognome: 'last name', nome: 'first name', data: 'date of birth or sex', luogo: 'place of birth' }
    }
  };

  /* Chiave di ricerca: minuscolo, senza accenti; apostrofi (anche quelli "curvi" di iOS) e
     trattini diventano spazi, così "Sant’Angelo", "Sant'Angelo" e "Sant Angelo" coincidono. */
  function normName(s) {
    return (s || '').toString().toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[’‘`´'\-]/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }

  /* ── Dati luoghi ─────────────────────────────────── */
  function setData(data) {
    var out = [], i, j, c, s, r, k;
    for (i = 0; i < data.comuni.length; i++) {
      c = data.comuni[i];
      out.push({ nome: c[0], cod: c[1], sigla: c[2], estero: false, keys: [normName(c[0])] });
    }
    for (i = 0; i < data.stati.length; i++) {
      s = data.stati[i];
      r = { nome: s[0], en: s[1], cod: s[2], sigla: '', estero: true, keys: [] };
      var names = [s[0], s[1]].concat(s[3] || []);
      for (j = 0; j < names.length; j++) {
        k = normName(names[j]);
        if (k && r.keys.indexOf(k) === -1) r.keys.push(k);
      }
      out.push(r);
    }
    /* indice per nome: in caso di omonimia vince il comune (es. Palau SS / Palau Z734);
       lo stato resta selezionabile dalla lista. */
    byName = {};
    for (i = 0; i < out.length; i++) {
      r = out[i];
      for (j = 0; j < r.keys.length; j++) { k = r.keys[j]; if (!byName[k]) byName[k] = r; }
    }
    luoghi = out;
  }

  function getDataUrl() {
    var el = document.querySelector('[data-pz-luoghi-url]');
    return el ? el.getAttribute('data-pz-luoghi-url') : '';
  }

  function flush() {
    loading = false;
    var q = waiting; waiting = [];
    for (var i = 0; i < q.length; i++) q[i](luoghi);
  }

  function loadLuoghi(cb) {
    if (luoghi) { cb(luoghi); return; }
    waiting.push(cb);
    if (loading) return;
    loading = true;
    var raw = null;
    try { sessionStorage.removeItem('pz_comuni_v1'); raw = sessionStorage.getItem(CACHE_KEY); } catch (_) {}
    if (raw) {
      try { setData(JSON.parse(raw)); flush(); return; } catch (_) { luoghi = null; }
    }
    var url = getDataUrl();
    if (!url) { loading = false; console.error('[pz-cart] manca data-pz-luoghi-url'); return; }
    fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (data) {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(data)); } catch (_) {}
      setData(data);
      flush();
    }).catch(function (e) {
      loading = false; /* i callback restano in coda: il prossimo input ritenta */
      console.error('[pz-cart] luoghi fetch error', e);
    });
  }

  function displayName(r, en) { return (en && r.estero && r.en) ? r.en : r.nome; }

  /* Ordine dei risultati (r.tier): comuni che iniziano con il testo → stati esteri (inizio del
     nome, di un alias o di una parola, IT ed EN) → comuni con una parola che inizia così
     ("aquila" → L'Aquila). Gli stati stanno prima dei comuni "per parola" perché con "alban"
     altrimenti Albania finiva dopo dieci "… Albanese". */
  function filterLuoghi(q) {
    if (!luoghi) return [];
    var qn = normName(q), prefix = [], word = [], stati = [], i, j, r, k;
    for (i = 0; i < luoghi.length; i++) {
      r = luoghi[i];
      if (!r.estero) {
        if (!qn) { if (prefix.length < 30) { r.tier = 'prefix'; prefix.push(r); } continue; }
        k = r.keys[0];
        if (k.indexOf(qn) === 0) { if (prefix.length < 40) { r.tier = 'prefix'; prefix.push(r); } }
        else if (word.length < 8 && k.indexOf(' ' + qn) !== -1) { r.tier = 'word'; word.push(r); }
      } else if (qn && stati.length < 12) {
        for (j = 0; j < r.keys.length; j++) {
          k = r.keys[j];
          if (k.indexOf(qn) === 0 || k.indexOf(' ' + qn) !== -1) { r.tier = 'stati'; stati.push(r); break; }
        }
      }
    }
    return prefix.concat(stati, word);
  }

  /* ── Algoritmo CF ────────────────────────────────── */
  var MONTH_LETTERS = ['A', 'B', 'C', 'D', 'E', 'H', 'L', 'M', 'P', 'R', 'S', 'T'];
  var VOWELS = 'AEIOU';
  function pad(n, w) { var s = '' + n; while (s.length < w) s = '0' + s; return s; }
  /* accenti e dieresi tolti prima di filtrare le lettere: "Zoë" → ZOE, come fa l'Agenzia */
  function letters(s) { return (s || '').toString().normalize('NFD').replace(/[̀-ͯ]/g, '').toUpperCase().replace(/[^A-Z]/g, ''); }
  function extractConsonants(s) {
    return letters(s).split('').filter(function (l) { return VOWELS.indexOf(l) === -1; }).join('');
  }
  function extractVowels(s) {
    return letters(s).split('').filter(function (l) { return VOWELS.indexOf(l) !== -1; }).join('');
  }
  function cfCognome(c) { return (extractConsonants(c) + extractVowels(c) + 'XXX').substring(0, 3); }
  function cfNome(n) {
    var cons = extractConsonants(n);
    if (cons.length >= 4) return cons[0] + cons[2] + cons[3];
    return (cons + extractVowels(n) + 'XXX').substring(0, 3);
  }
  function cfYearMonthDay(dataIso, sesso) {
    var parts = dataIso.split('-');
    var yyyy = parseInt(parts[0], 10);
    var mIdx = parseInt(parts[1], 10) - 1;
    var dd = parseInt(parts[2], 10);
    if (sesso === 'F') dd += 40;
    return pad(yyyy % 100, 2) + MONTH_LETTERS[mIdx] + pad(dd, 2);
  }
  function cfCIN(code15) {
    var ODD = { '0': 1, '1': 0, '2': 5, '3': 7, '4': 9, '5': 13, '6': 15, '7': 17, '8': 19, '9': 21,
      'A': 1, 'B': 0, 'C': 5, 'D': 7, 'E': 9, 'F': 13, 'G': 15, 'H': 17, 'I': 19, 'J': 21,
      'K': 2, 'L': 4, 'M': 18, 'N': 20, 'O': 11, 'P': 3, 'Q': 6, 'R': 8, 'S': 12, 'T': 14,
      'U': 16, 'V': 10, 'W': 22, 'X': 25, 'Y': 24, 'Z': 23 };
    var EVEN = { '0': 0, '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9,
      'A': 0, 'B': 1, 'C': 2, 'D': 3, 'E': 4, 'F': 5, 'G': 6, 'H': 7, 'I': 8, 'J': 9,
      'K': 10, 'L': 11, 'M': 12, 'N': 13, 'O': 14, 'P': 15, 'Q': 16, 'R': 17, 'S': 18, 'T': 19,
      'U': 20, 'V': 21, 'W': 22, 'X': 23, 'Y': 24, 'Z': 25 };
    var sum = 0;
    for (var i = 0; i < 15; i++) {
      var ch = code15[i];
      sum += (i % 2 === 0) ? ODD[ch] : EVEN[ch];
    }
    return String.fromCharCode(65 + (sum % 26));
  }
  function computeCF(nome, cognome, dataIso, sesso, codCatastale) {
    if (!nome || !cognome || !dataIso || !sesso || !codCatastale) return '';
    var code15 = cfCognome(cognome) + cfNome(nome) + cfYearMonthDay(dataIso, sesso) + codCatastale.toUpperCase();
    return code15 + cfCIN(code15);
  }

  /* ── Controllo del CF scritto a mano ─────────────── */
  var OMO = { L: '0', M: '1', N: '2', P: '3', Q: '4', R: '5', S: '6', T: '7', U: '8', V: '9' };
  var OMO_POS = [6, 7, 9, 10, 12, 13, 14];
  var CF_RE = /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST][0-9LMNPQRSTUV]{2}[A-Z][0-9LMNPQRSTUV]{3}[A-Z]$/;

  function cleanCF(s) { return (s || '').toString().toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  /* omocodia: le cifre sostituite da lettere (L=0 … V=9) tornano cifre, per il confronto */
  function deomocode(cf) {
    var a = cf.split('');
    for (var i = 0; i < OMO_POS.length; i++) { var p = OMO_POS[i]; if (OMO[a[p]]) a[p] = OMO[a[p]]; }
    return a.join('');
  }
  /* 'ok' | 'format' | 'cin' */
  function checkCF(cf) {
    if (!CF_RE.test(cf)) return 'format';
    if (cfCIN(cf.substring(0, 15)) !== cf.charAt(15)) return 'cin';
    return 'ok';
  }
  /* {result: 'equal'|'omocodia'|'diff', parts: ['cognome'|'nome'|'data'|'luogo']} */
  function compareCF(manual, computed) {
    if (manual === computed) return { result: 'equal', parts: [] };
    var a = deomocode(manual).substring(0, 15), b = computed.substring(0, 15);
    if (a === b) return { result: 'omocodia', parts: [] };
    var parts = [];
    if (a.substring(0, 3) !== b.substring(0, 3)) parts.push('cognome');
    if (a.substring(3, 6) !== b.substring(3, 6)) parts.push('nome');
    if (a.substring(6, 11) !== b.substring(6, 11)) parts.push('data');
    if (a.substring(11, 15) !== b.substring(11, 15)) parts.push('luogo');
    return { result: 'diff', parts: parts };
  }

  /* ── Combobox (comune o stato) ───────────────────── */
  function initCombobox(input, listEl, T, en, onPick) {
    var activeIdx = -1;
    var matches = [];

    function escapeHtml(s) { return ('' + s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

    function render(list) {
      listEl.innerHTML = '';
      activeIdx = -1;
      if (!list.length) {
        var empty = document.createElement('li');
        empty.className = 'pz-cart-v2__combo-empty';
        empty.textContent = T.empty;
        listEl.appendChild(empty);
        listEl.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        return;
      }
      var frag = document.createDocumentFragment();
      var prevTier = null;
      list.forEach(function (c, i) {
        /* intestazione quando cambia il gruppo (stati esteri / altri comuni), mai in testa */
        if (i > 0 && c.tier !== prevTier && T.groups[c.tier]) {
          var g = document.createElement('li');
          g.className = 'pz-cart-v2__combo-group';
          g.setAttribute('role', 'presentation');
          g.textContent = T.groups[c.tier];
          frag.appendChild(g);
        }
        prevTier = c.tier;
        var li = document.createElement('li');
        li.className = 'pz-cart-v2__combo-item';
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.dataset.idx = i;
        li.innerHTML = '<span>' + escapeHtml(displayName(c, en)) + '</span><span class="pz-cart-v2__combo-item-sigla' + (c.estero ? ' pz-cart-v2__combo-item-sigla--estero' : '') + '">' + escapeHtml(c.estero ? T.estero : c.sigla) + '</span>';
        li.addEventListener('mousedown', function (e) { e.preventDefault(); pick(i); });
        li.addEventListener('mouseenter', function () { setActive(i); });
        frag.appendChild(li);
      });
      listEl.appendChild(frag);
      listEl.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      listEl.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIdx = -1;
    }

    function setActive(i) {
      var items = listEl.querySelectorAll('.pz-cart-v2__combo-item');
      items.forEach(function (el) { el.setAttribute('aria-selected', 'false'); });
      activeIdx = i;
      if (i >= 0 && items[i]) {
        items[i].setAttribute('aria-selected', 'true');
        items[i].scrollIntoView({ block: 'nearest' });
      }
    }

    function pick(i) {
      if (i < 0 || i >= matches.length) return;
      var c = matches[i];
      input.value = displayName(c, en);
      close();
      input.blur();
      if (onPick) onPick(c);
    }

    function refresh() {
      loadLuoghi(function () {
        matches = filterLuoghi(input.value);
        render(matches);
      });
    }

    input.addEventListener('focus', refresh);
    input.addEventListener('input', refresh);
    input.addEventListener('blur', function () { setTimeout(close, 150); });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        if (listEl.hidden) { refresh(); return; }
        setActive(Math.min(activeIdx + 1, matches.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setActive(Math.max(activeIdx - 1, 0));
      } else if (e.key === 'Enter') {
        if (!listEl.hidden && activeIdx >= 0) {
          e.preventDefault();
          pick(activeIdx);
        }
      } else if (e.key === 'Escape') {
        close();
      }
    });

    document.addEventListener('click', function (e) {
      if (!input.contains(e.target) && !listEl.contains(e.target)) close();
    });

    return { open: refresh, close: close };
  }

  /* ── Wire-up ─────────────────────────────────────── */
  function ready() {
    var $ = function (id) { return document.getElementById(id); };
    var cog = $('pz-cf-cognome'), nome = $('pz-cf-nome'), data = $('pz-cf-data'), sesso = $('pz-cf-sesso');
    var comune = $('pz-cf-comune'), comuneList = $('pz-cf-comune-list');
    var cf = $('pz-cart-cf'), err = $('pz-cf-err');
    var warn = $('pz-cf-warn'), warnText = $('pz-cf-warn-text'), recalcBtn = $('pz-cf-recalc');
    var calcHidden = $('pz-cf-calc'), checkHidden = $('pz-cf-check');
    if (!cog || !nome || !data || !sesso || !comune || !cf) return;

    var en = (document.documentElement.getAttribute('lang') || 'it').toLowerCase().indexOf('en') === 0;
    var T = en ? TEXTS.en : TEXTS.it;

    var cfUserEdited = false;   // true: il CF lo gestisce l'utente, non si sovrascrive
    var isAutoSetting = false;
    var picked = null;          // record scelto dalla lista (vince sull'omonimia comune/stato)
    var lastComputed = '';      // CF calcolato dai dati (o '' se non calcolabile)
    var firstRun = true;
    var initialCF = cleanCF(cf.value);

    function resolveLuogo() {
      var key = normName(comune.value);
      if (!key) return null;
      if (picked && picked.keys.indexOf(key) !== -1) return picked;
      return byName[key] || null;
    }

    function computeFromFields() {
      var r = resolveLuogo();
      if (!nome.value.trim() || !cog.value.trim() || !data.value || !sesso.value || !r) return '';
      try { return computeCF(nome.value, cog.value, data.value, sesso.value, r.cod); } catch (_) { return ''; }
    }

    function setCF(v) { isAutoSetting = true; cf.value = v; isAutoSetting = false; }

    function showMessages(msgErr, msgWarn, showRecalc) {
      if (err) err.textContent = msgErr;
      cf.setAttribute('aria-invalid', msgErr ? 'true' : 'false');
      if (warn) {
        if (warnText) warnText.textContent = msgWarn;
        warn.hidden = !msgWarn && !showRecalc;
        warn.classList.toggle('pz-cart-v2__cfwarn--info', !!msgWarn && (msgWarn === T.unverifiable || msgWarn === T.omocodia));
      }
      if (recalcBtn) recalcBtn.hidden = !showRecalc;
    }

    /* Aggiorna gli attributi "CF calcolato" / "Controllo CF" e, se show, i messaggi sotto il campo. */
    function updateStatus(show) {
      var val = cleanCF(cf.value);
      var status = '', msgErr = '', msgWarn = '', showRecalc = false;
      if (val) {
        var chk = checkCF(val);
        if (chk !== 'ok') {
          status = ST_EDIT_INVALID;
          msgErr = chk === 'format' ? T.invalidFormat : T.invalidCin;
          showRecalc = !!lastComputed;
        } else if (!cfUserEdited) {
          status = ST_OK;
        } else if (!lastComputed) {
          status = ST_UNVERIFIABLE;
          msgWarn = T.unverifiable;
        } else {
          var cmp = compareCF(val, lastComputed);
          if (cmp.result === 'equal') { status = ST_OK; cfUserEdited = false; }
          else if (cmp.result === 'omocodia') { status = ST_EDIT_OK; msgWarn = T.omocodia; showRecalc = true; }
          else {
            status = ST_EDIT_DIFF;
            msgErr = T.mismatch.replace('{parts}', cmp.parts.map(function (p) { return T.parts[p]; }).join(', '));
            showRecalc = true;
          }
        }
      }
      if (calcHidden) calcHidden.value = lastComputed || CALC_NONE;
      if (checkHidden) checkHidden.value = status;
      if (show) showMessages(msgErr, msgWarn, showRecalc);
      else showMessages('', '', false);
      return status !== ST_EDIT_INVALID && status !== ST_EDIT_DIFF;
    }

    function recompute() {
      if (!luoghi) { loadLuoghi(recompute); return; }
      lastComputed = computeFromFields();
      if (firstRun) {
        firstRun = false;
        /* CF salvato in una visita precedente e diverso dal calcolato: era stato scritto
           a mano, non lo sovrascriviamo (prima il ricalcolo al caricamento lo cancellava). */
        if (initialCF && initialCF !== lastComputed) { cfUserEdited = true; setCF(initialCF); }
      }
      if (!cfUserEdited) setCF(lastComputed);
      updateStatus(true);
    }

    if (comuneList) initCombobox(comune, comuneList, T, en, function (r) { picked = r; recompute(); });

    /* nota: il listener "change" in capture su <cart-items> (pizeta-cart.liquid) ferma i change
       dei campi non-quantità, quindi qui si usano solo input e blur */
    [cog, nome, data, sesso, comune].forEach(function (el) {
      el.addEventListener('input', recompute);
    });

    cf.addEventListener('input', function () {
      if (isAutoSetting) return;
      if (!cf.value.trim()) { cfUserEdited = false; recompute(); return; }
      cfUserEdited = true;
      /* mentre si scrive niente messaggi; a 16 caratteri l'esito compare subito */
      updateStatus(cleanCF(cf.value).length >= 16);
    });
    cf.addEventListener('blur', function () {
      var v = cleanCF(cf.value);
      if (v !== cf.value) setCF(v);
      updateStatus(true);
    });

    if (recalcBtn) recalcBtn.addEventListener('click', function () {
      cfUserEdited = false;
      recompute();
      /* il codice ricalcolato è valido: via anche l'errore nel riepilogo lasciato da un checkout bloccato */
      var er = document.getElementById('checkout-cf-error');
      if (er) er.style.display = 'none';
      cf.focus();
    });

    /* usato da validateCF() in pizeta-cart.liquid prima del checkout */
    root.pzCartCF = {
      validate: function () {
        var v = cleanCF(cf.value);
        if (v !== cf.value) setCF(v);
        return updateStatus(true);
      }
    };

    loadLuoghi(function () { recompute(); });
  }

  var api = {
    normName: normName, computeCF: computeCF, cfCIN: cfCIN, cleanCF: cleanCF, deomocode: deomocode,
    checkCF: checkCF, compareCF: compareCF, setData: setData, filterLuoghi: filterLuoghi,
    lookup: function (name) { return byName[normName(name)] || null; }
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
    else ready();
  }
})(typeof window !== 'undefined' ? window : this);
